
const CustomerMasterImageUpload = async ({ picture, strCusCode }) => {

    var message
    const ApiURL = window.Links.ApiURL

    var formdata = new FormData()
    formdata.append("strCode", strCusCode)
    formdata.append("img", picture.imageFile)

    var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };

    await fetch(`${ApiURL}customer/image`, requestOptions)
        .then(response => response.text())
        .then(result => {
            console.log(result)
            message = result
        }

        )
        .catch(error => console.log('error', error));

    return message
}



const SaveCustomer = async (customer) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        var requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
            body: customer
        };

        const response = await fetch(`${ApiURL}customer`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200" && responseData.success == true) {
            return { success: true, data: responseData.data };
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("SaveCustomer error:", error);
        return { success: false, data: "An error occurred." };
    }
};
// *

export {
    CustomerMasterImageUpload,
    SaveCustomer
}

